import {createAction} from 'redux-actions';
import {DashboardData, EmployeeRate, YearlyRevenueData} from '../types/Dashboard';

const createDashboardEvent = <T>(type: string) => createAction<T>('_E/DB/' + type);

export interface DashboardDataFetchedPayload {
    data: DashboardData;
}

export interface EmployeeRateListFetchedPayload {
    rates: EmployeeRate[];
}

export interface YearlyRevenueFetchedPayload {
    data: YearlyRevenueData;
}

const DashboardEvent = {
    dashboardDataFetched: createDashboardEvent<DashboardDataFetchedPayload>('DASHBOARD_DATA_FETCHED'),
    employeeRateListFetched:
        createDashboardEvent<EmployeeRateListFetchedPayload>('EMPLOYEE_RATE_LIST_FETCHED'),
    yearlyRevenueFetched:
        createDashboardEvent<YearlyRevenueFetchedPayload>('YEARLY_REVENUE_FETCHED'),
};

export default DashboardEvent;
